import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalServicesComponent } from '@cemex-core/msal-services-v1';
import { CmxClientLayoutComponent, LoginComponent, LoginGuard } from '@cemex/cmx-client-layout';
import { AuthFactoryGuard } from './core/guards/auth-factory.guard';

const routes: Routes = [
  {
    path: '',
    component: CmxClientLayoutComponent,
    canActivate: [AuthFactoryGuard],
    children: [
      {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
      },
      {
        path: 'app',
        loadChildren: () =>
          import('./launchers/ordersnproducts-launcher.module').then((m) => m.OrdersnproductsLauncherModule),
        canActivate: [AuthFactoryGuard],
        canActivateChild: [AuthFactoryGuard],
      },
      {
        path: 'calendar-view',
        loadChildren: () =>
          import('./launchers/calendar-view-launcher.module').then((m) => m.CalendarViewLauncherModule),
        canActivate: [AuthFactoryGuard],
        canActivateChild: [AuthFactoryGuard],
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'login/auth',
    component: MsalServicesComponent,
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: 'app' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
  providers: [MsalGuard, LoginGuard, AuthFactoryGuard],
})
export class AppRoutingModule {}
